<template>
    <div>
        <row v-if="market.odd && Object.values(market.odd).length <= 3" :odd="market" :match="match" :selectedOdds="selectedOdds" />
        <block v-if="market.odd && Object.values(market.odd).length > 3" :odd="market" :match="match" :selectedOdds="selectedOdds" />
        <!-- <score v-if="market.template === 'Score'" :odd="market" :match="match" :selectedOdds="selectedOdds" /> !-->
    </div>
</template>

<script>

    import row from './template/row'
    import score from './template/score'
    import block from './template/block'
    export default {
        name: "market",
        components: {row, score, block},
        props: ['market', 'match'],
        data () {
            return {
                selectedOdds: []
            }
        },
        mounted (){
            this.$bus.$on('addBet', ($event) => {

                this.selectedOdds = $event;

            })
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/sportsbook/market/market.vue